<template>
    <v-container fluid>
        <v-card
            class="ma-8"
        >
            <v-card-text>
                <p class="display-1 text--primary">
                    Login
                </p>
                <p>We are processing your login information.</p>
                <div class="text--primary">
                    If you are not redirected automaticaly after a few seconds, please click the button below.
                </div>
            </v-card-text>
            <v-card-actions>
            <v-btn
                text
                color="teal accent-4"
                @click="mgr.signOut()"
            >
                Reload
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Mgr from '@/SecurityService'

export default {
    data: () => ({
        mgr: new Mgr(),
        redirect: "/"
    }),
    created() {
        this.redirect = this.$route.query.redirect || "/";
    },
    computed: {
        ...mapGetters(['getPermissions'])
    },
    watch: {
        getPermissions() {
            this.$router.push(this.redirect).catch((e) => console.log(e));
        }
    }
}
</script>

<style>

</style>